<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="广告板块设置"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12" v-if="1 == 2">
            <el-form-item label="板块名称" prop="SectionId">
              <el-select
                v-model="data.SectionId"
                placeholder="请选择板块名称"
                clearable
                disabled
              >
                <el-option
                  v-for="item in listbk"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.SectionName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="广告主题" prop="PhotoTitle">
              <el-input
                v-model="data.PhotoTitle"
                placeholder="请填写广告主题"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接类型" prop="AdType">
              <el-select
                v-model="data.AdType"
                placeholder="请选择链接类型"
                clearable
              >
                <el-option label="静态展示" :value="0"></el-option>
                <!-- <el-option label="活动链接" :value="1"></el-option> -->
                <!-- <el-option label="页面链接" :value="2"></el-option> -->
                <el-option label="商品分类" :value="3"></el-option>
                <el-option label="指定商品" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12" v-if="data.AdType == 1">
            <el-form-item label="活动类别" prop="PromotionType">
              <el-select
                v-model="data.PromotionType"
                placeholder="请选择活动类别"
                @change="getpromotionname"
                clearable
              >
                <!--下拉触发事件change-->
                <el-option label="团购" :value="0"></el-option>
                <el-option label="秒杀" :value="1"></el-option>
                <el-option label="折扣" :value="2"></el-option>
                <el-option label="满送" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12" v-if="data.AdType == 1">
            <el-form-item label="活动名称" prop="PromotionId">
              <el-select
                v-model="data.PromotionId"
                placeholder="请选择活动名称"
                clearable
              >
                <el-option
                  v-for="item in listhd"
                  :key="item.RecordId"
                  :value="item.RecordId"
                  :label="item.Opername"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.AdType == 2">
            <el-form-item label="链接地址" prop="LinkAddress">
              <el-input
                v-model="data.LinkAddress"
                placeholder="请填写链接地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.AdType == 3">
            <el-form-item label="商品分类" prop="GoodsTypeId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TypePlatforms"
                :value="data.GoodsTypeId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.AdType == 4">
            <el-form-item label="商品名称" prop="GoodsName">
              <el-input
                v-model="data.GoodsName"
                placeholder="点击选择"
                readonly
                suffix-icon="el-icon-search"
                @focus="onGoodsDialog"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="电脑端图片上传" prop="PhotoAddress">
              <single-pic-upload v-model="data.PhotoAddress" type="PhotoAddress" :uploadUrl="uploadUrl"></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片上传" prop="PhotoAddressmobile">
              <single-pic-upload
                v-model="data.PhotoAddressmobile"
                type="PhotoAddressmobile"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽长比例5：12</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import treeSelect from "@/components/common/treeSelect";
import goodsDialog from "@/components/goods/info/listDialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    treeSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        SectionId: "",
        PhotoTitle: "",
        PhotoAddress: "",
        PhotoAddressmobile: "",
        AdType: 0,
        PromotionType: "",
        PromotionId: "",
        LinkAddress: "",
        OrderId: 0,
        GoodsTypeId: null,
        GoodsId: null,
        GoodsName: "",
      },
      listbk: [],
      listhd: [],
      api: require("@/api/mall/sectionad").default,
      api2: require("@/api/mall/section").default,
      api3: require("@/api/sale/activity/group").default,
      api4: require("@/api/goods/typeplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        PhotoTitle: [{ required: true, message: "广告主题不能为空" }],
        //PhotoAddress: [{ required: true, message: "广告图片不能为空" }],
        PhotoAddressmobile: [{ required: true, message: "广告图片不能为空" }],
        LinkAddress: [
          { required: true, message: "链接地址不能为空" },
          { validator: this.$commonJs.validateRules.validUrl },
        ],
        PromotionType: [{ required: true, message: "活动类型不能为空" }],
        PromotionId: [{ required: true, message: "活动名称不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  watch: {
    //监听
    "data.AdType": {
      //监听AdType的值，
      handler(val) {
        if (val != 1) {
          //如果链接类型不是活动，则需要对活动类型和活动名称清空
          this.data.PromotionId = null;
          this.data.PromotionType = null;
        }
      },
    },
  },
  methods: {
    onGoodsDialog() {
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ SaleState: 1 });
        that.getTree();
      });
    },
    setGoods(t) {
      console.log(t, "setgoods");
      this.data.GoodsId = t.RecordId;
      this.data.GoodsName = t.GoodsName;
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.GoodsTypeName = "";
        this.data.GoodsTypeId = null;
      } else {
        this.data.GoodsTypeName = t.TypepName;
        this.data.GoodsTypeId = t.RecordId;
      }
    },
    onCreateOpened(row) {
      this.getOption();
      console.log(row);
      this.api.getMaxOrderId(row.SectionId).then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.getOption();
      if (this.data.PromotionType) {
        //打开编辑的时候，根据保存过的活动类型的值，传入去提取对应的活动名称加入到活动名称下拉
        this.api3
          .OperList({ Opertype: this.data.PromotionType })
          .then((res) => {
            if (res.Code == 0) {
              this.listhd = res.Data;
            }
          });
      }
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1, SectionType: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.listbk = res.Data;
        }
      });

      this.api4.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.TypePlatforms = this.$commonJs.toTreeData(
            res.Data,
            "RecordId",
            "TypeIdParent",
            "children"
          );
          if(this.$refs.treeSelect){
            this.$refs.treeSelect.setData();
          }
        }
      });
    },
    getpromotionname(val) {
      //下拉框会自动将当前的值作为参数传入，也就是val会传入0，1，2
      this.data.PromotionId = null;
      this.api3.OperList({ Opertype: val }).then((res) => {
        if (res.Code == 0) {
          this.listhd = res.Data;
        }
      });
    },
    onBeforeSave() {},
    onClosed() {
      this.listbk = [];
      this.listhd = [];
    },
  },
};
</script>